export const environment = {
  production: false,
  auth0: {
    clientID: "RDyU63VexvuK3d2RIfVXA0n4IiBTCMbB",
    domain: "much-smarter.auth0.com",
    audience: "https://much-smarter.auth0.com/api/v2/",
    grant_type: "http://auth0.com/oauth/grant-type/password-realm",
    loginUrl: "https://much-smarter.auth0.com/oauth/token",
    realm: "Username-Password-Authentication",
    logoutUrl: "https://much-smarter.auth0.com/v2/logout?returnTo=",
    // redirectUri: '/callback',
  },
  msApiUrl: "https://api-ms.wtt-solutions.net/admin/",
  msStudentApiUrl: "https://api-ms.wtt-solutions.net/student/",
};
